import PropTypes from 'prop-types';
import { createRef, useState } from 'react';
import { Button } from '@ui-propulsion/react-components';
import parse from 'html-react-parser';
import styles from './prequalOffer.module.scss';
import * as defaults from '../constants';
import Tooltip from '../../toolTip/toolTip';
import Modal from '../../modalPopup/modalPopup';

function PrequalOffer({
  url = defaults.url,
  title = defaults.title,
  tooltip = defaults.tooltip,
  prequalType = defaults.prequalType,
  ctaLabel = defaults.ctaLabel,
  offerCodePlaceholder = defaults.offerCodePlaceholder,
  popupHead,
  popupBody,
  popupFooter,
}) {
  const offerCode = createRef();
  const [hasOfferCodeError, setHasOfferCodeError] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleSubmit = () => {
    let hasError = false;
    const offerCodeValue = offerCode ? offerCode.current.value : '';
    if (prequalType === 'Offer code') {
      if (!offerCodeValue.match(/^[a-zA-Z0-9\d]{12,}$/)) {
        setHasOfferCodeError('A valid offer code is required');
        hasError = true;
      } else {
        setHasOfferCodeError('');
      }
    }
    if (!hasError) window.location.assign(`${url}`);
  };
  return (
    <div className={styles.wrapper}>
      {title && <h2 className={styles.title}>{title}</h2>}
      <div className={styles.offercodeWrapper}>
        <input
          ref={offerCode}
          className={
            hasOfferCodeError
              ? `${styles.offerCodeInputError} ${styles.offerCodeInput}`
              : styles.offerCodeInput
          }
          data-testid="offerCode-id"
          placeholder={offerCodePlaceholder}
          maxLength={12}
        />
      </div>
      {hasOfferCodeError && (
        <span className={styles.errorOfferCode}> {hasOfferCodeError}</span>
      )}
      {popupHead && (
        <div className={styles.tooltipPopup}>
          <span
            onClick={() => setIsModalOpen(true)}
            onKeyDown={() => setIsModalOpen(true)}
            data-testid="tooltip-popup"
            aria-label="find my code"
            role="button"
            tabIndex="0"
            className={styles.popupLabel}
          >
            {popupHead}
          </span>
        </div>
      )}
      <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
        <div className={styles.popupBody}>
          {parse(`${popupBody}`)}
          <Button
            onClick={() => setIsModalOpen(false)}
            onKeyDown={() => setIsModalOpen(false)}
            className={styles.popupFound}
            tabIndex="0"
            type="button"
            data-id="direct-mail-button"
            data-analytics="direct-mail-button"
            name="button"
            color="red"
            variant="secondary"
          >
            Found It!
          </Button>
          <div className={styles.popupFooter}>{popupFooter}</div>
        </div>
      </Modal>
      <Button
        color="red"
        variant="primary"
        fullWidth
        type="submit"
        data-testid="check-rate"
        className={styles.submitBtn}
        aria-label="submit-rate"
        onClick={handleSubmit}
      >
        {ctaLabel}
      </Button>
      {tooltip && (
        <div className={styles.tooltip}>
          <span className={styles.tooltipNote}>{tooltip.note}</span>
          {tooltip.helpNote && <Tooltip message={tooltip.helpNote} />}
        </div>
      )}
    </div>
  );
}

PrequalOffer.propTypes = {
  url: PropTypes.string,
  title: PropTypes.string,
  tooltip: PropTypes.shape({
    note: PropTypes.string,
    helpNote: PropTypes.string,
  }),
  ctaLabel: PropTypes.string,
  prequalType: PropTypes.string,
  offerCodePlaceholder: PropTypes.string,
};

export default PrequalOffer;
